__turbopack_context__.v({
  "grid": "IvLoungeLineupSection-module__TX-lzG__grid",
  "header": "IvLoungeLineupSection-module__TX-lzG__header",
  "planCardAnchor": "IvLoungeLineupSection-module__TX-lzG__planCardAnchor",
  "shell": "IvLoungeLineupSection-module__TX-lzG__shell",
  "tabBar": "IvLoungeLineupSection-module__TX-lzG__tabBar",
  "tabItem": "IvLoungeLineupSection-module__TX-lzG__tabItem",
});
